export const fetchVisits = async (apiClient, id_pt) => {
  const { data } = await apiClient.get(`/visits/patient/${id_pt}`);
  return data;
};

export const fetchVisit = async (apiClient, id) => {
  const { data } = await apiClient.get(`/visits/${id}`);
  return data;
};

export const createVisit = async (apiClient, payload) => {
  const { data } = await apiClient.post('/visits', payload);
  return data;
};

export const updateVisit = async (apiClient, id, payload) => {
  const { data } = await apiClient.put(`/visits/${id}`, payload);
  return data;
};

export const deleteVisit = async (apiClient, id) => {
  await apiClient.delete(`/visits/${id}`);
};
